import { render, staticRenderFns } from "./uploadDocuments.vue?vue&type=template&id=d53ca09e&scoped=true"
import script from "./uploadDocuments.vue?vue&type=script&lang=js"
export * from "./uploadDocuments.vue?vue&type=script&lang=js"
import style0 from "./uploadDocuments.vue?vue&type=style&index=0&id=d53ca09e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53ca09e",
  null
  
)

export default component.exports